module.exports = __webpack_public_path__ + "img/Rwanda.d0f3170f.gif";